export const add=(payload)=>{
    return{
        type:'ADDFAV',
        data:payload

    }
}

export const remove=(payload)=>{
    return{
        type:'REMOVEFAV',
        data:payload
    }
}
export const addkfr=(payload)=>{
    return{
        type:'ADDFAVKFRS',
        data:payload
    }
}
export const addfilter=(payload)=>{
    return{
        type:'ADDFILTER',
        data:payload
    }
}
